import React from "react";
import Marquee from "react-fast-marquee";

const items = [
    "$LBRON",
    "LEBONBON",
    "JUST A SMALL GUY, HOLDING HIS CUP",
    "LAUNCHING ON PUMP.FUN",
    "MAY 20",
    "PHASE 1 LIVE",
];

export const MarqueeBar = ({ variant = "pink" }) => {
    const bg = variant === "pink" ? "bg-pink-brand" : "bg-yellow-brand";
    const text = variant === "pink" ? "text-white" : "text-[#0a0806]";
    return (
        <div data-testid={`marquee-${variant}`} className={`${bg} ${text} py-4 border-y-2 border-black/20`}>
            <Marquee speed={60} gradient={false}>
                {items.concat(items).map((it, i) => (
                    <span key={i} className="font-display text-2xl sm:text-3xl uppercase mx-8 tracking-tight">
                        {it} <span className="mx-4 opacity-70">★</span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
};
